import { Slider } from "../../../components/ui/slider";

export default function GranularitySlider(props: {
  showGranularity: boolean
  granularity: number
  setGranularity: React.Dispatch<React.SetStateAction<number>>
  maxGranularity?: number
}) {

  const {
    showGranularity,
    granularity,
    setGranularity,
    maxGranularity
  } = props;

  const handleGranularityChange = (value: number[]) => {
    value.length > 0 && setGranularity(value[0])
  }

  if (!showGranularity) return null;

  const getGranularityLabel = () => {
    switch (granularity) {
      case 0: return 'Domain';
      case 1: return 'Table';
      case 2: return 'Column';
      default: return `Level ${granularity}`;
    }
  };

  return (
    <div className="flex flex-col gap-3 items-start min-w-[240px] px-4 py-3 pb-4 bg-slate-900/90 backdrop-blur-md rounded-lg border border-blue-500/20 shadow-xl shadow-blue-500/10">
        <div className="flex items-center justify-between w-full">
          <label className="text-[11px] font-semibold text-slate-300 uppercase tracking-wider" htmlFor={"gr-slider"}>
            Granularity
          </label>
          <span className="text-[11px] font-medium text-blue-400 bg-blue-500/15 px-2 py-0.5 rounded border border-blue-500/30">
            {getGranularityLabel()}
          </span>
        </div>
        <div className="w-full px-1 pb-1">
            <Slider 
                id="gr-slider" 
                defaultValue={[granularity]} 
                value={[granularity]}  
                max={maxGranularity ?? 2} 
                step={1} 
                onValueChange={handleGranularityChange}
                className="cursor-pointer"
            />
        </div>
    </div>
  )
}
